import { InputText } from "primereact/inputtext"
import { classNames } from "primereact/utils"
import { Controller } from "react-hook-form"

interface IInput {
    label?: string,
    name: string,
    type?: string,
    control: any,
    error?: string,
    maxLength?: number,
    required?: boolean,
    disabled?: boolean,
    placeholder?: string,
    column?: number,
    onBlur?: () => void
}

export const JVInput = (props: IInput) => {
    const className = props.column ? `field col-12 md:col-${12 / props.column}` : "field col-12 md:col-6";
    return (
        <div className={className}>
            {props.label && <label htmlFor={props.name}>{props.label}{props.required && <span style={{ color: 'red' }}>*</span>}</label>}
            <Controller name={props.name} control={props.control} render={({ field, fieldState }) => (
                <InputText {...field} maxLength={props.maxLength} onBlur={props.onBlur}
                    disabled={props.disabled}
                    placeholder={props.placeholder} type={props.type ? props.type : "text"}
                    className={classNames({ 'p-invalid': fieldState.invalid })} />
            )} />
            <small className="p-error" >{props.error}</small>
        </div>
    );
}